import { useState } from 'react';

const TIPOS_CANCHA = [
  { id: 'futbol5',  label: 'Fútbol 5',   icono: '⚽' },
  { id: 'futbol7',  label: 'Fútbol 7',   icono: '⚽' },
  { id: 'futbol11', label: 'Fútbol 11',  icono: '⚽' },
  { id: 'padel',    label: 'Pádel',      icono: '🎾' },
  { id: 'tenis',    label: 'Tenis',      icono: '🎾' },
];

const SUPERFICIES = [
  'Pasto sintético', 'Pasto natural', 'Cemento',
  'Madera', 'Arena', 'Carpeta', 'Superficie dura',
];

// Mismas franjas que usa el Panel Recinto — mantener sincronizado si se edita ahí
const FRANJAS_HORAS = [
  { id: 'manana', label: 'Mañana', horas: ['07:00','08:00','09:00','10:00','11:00'] },
  { id: 'tarde',  label: 'Tarde',  horas: ['12:00','13:00','14:00','15:00','16:00','17:00'] },
  { id: 'noche',  label: 'Noche',  horas: ['18:00','19:00','20:00','21:00','22:00'] },
];

export default function StepCanchas({ datos, onNext, onBack }) {
  const [canchas, setCanchas] = useState(
    datos.canchas || [{ tipo: '', nombre: '', superficie: '', precio: '', techada: false, horas_disponibles: [] }]
  );
  const [error, setError] = useState('');
  // Franjas abiertas por cancha: { [index]: ['manana', ...] }
  const [franjasAbiertas, setFranjasAbiertas] = useState({});

  const actualizar = (index, campo, valor) => {
    setCanchas(prev => prev.map((c, i) =>
      i === index ? { ...c, [campo]: valor } : c
    ));
  };

  const toggleFranja = (index, franjaId) => {
    setFranjasAbiertas(prev => {
      const abiertas = prev[index] || [];
      const nuevas = abiertas.includes(franjaId)
        ? abiertas.filter(x => x !== franjaId)
        : [...abiertas, franjaId];
      return { ...prev, [index]: nuevas };
    });
  };

  const toggleHora = (index, hora) => {
    setCanchas(prev => prev.map((c, i) => {
      if (i !== index) return c;
      const horas = c.horas_disponibles || [];
      return {
        ...c,
        horas_disponibles: horas.includes(hora)
          ? horas.filter(x => x !== hora)
          : [...horas, hora],
      };
    }));
  };

  const agregar = () => {
    setCanchas(prev => [
      ...prev,
      { tipo: '', nombre: '', superficie: '', precio: '', techada: false, horas_disponibles: [] }
    ]);
  };

  const eliminar = (index) => {
    if (canchas.length <= 1) return;
    setCanchas(prev => prev.filter((_, i) => i !== index));
    setFranjasAbiertas(prev => {
      const { [index]: _omit, ...resto } = prev;
      return resto;
    });
  };

  const handleNext = () => {
    const validas = canchas.filter(c => c.tipo && c.precio);
    if (validas.length === 0) {
      setError('Agrega al menos una cancha con tipo y precio');
      return;
    }
    setError('');
    onNext({ canchas: validas });
  };

  return (
    <div style={styles.wrap}>
      <h2 style={styles.titulo}>Canchas disponibles</h2>
      <p style={styles.sub}>
        Agrega todas las canchas de tu recinto. Los equipos
        verán su disponibilidad al momento de desafiarse.
      </p>

      <div style={styles.canchasList}>
        {canchas.map((cancha, index) => (
          <div key={index} style={styles.canchaCard}>
            <div style={styles.canchaHeader}>
              <div style={styles.canchaNum}>Cancha {index + 1}</div>
              {canchas.length > 1 && (
                <button
                  style={styles.eliminarBtn}
                  onClick={() => eliminar(index)}
                >
                  Eliminar
                </button>
              )}
            </div>

            {/* Tipo de cancha */}
            <div style={styles.campo}>
              <label style={styles.label}>Tipo</label>
              <div style={styles.tiposGrid}>
                {TIPOS_CANCHA.map(({ id, label, icono }) => (
                  <div
                    key={id}
                    onClick={() => actualizar(index, 'tipo', id)}
                    style={{
                      ...styles.tipoCard,
                      border: `2px solid ${cancha.tipo === id ? '#1A6BFF' : '#E8ECF4'}`,
                      background: cancha.tipo === id ? '#EFF5FF' : 'white',
                    }}
                  >
                    <div style={styles.tipoIcono}>{icono}</div>
                    <div style={styles.tipoLabel}>{label}</div>
                  </div>
                ))}
              </div>
            </div>

            {/* Nombre y superficie */}
            <div style={styles.rowDos}>
              <div style={{ flex: 1 }}>
                <label style={styles.label}>Nombre de la cancha</label>
                <input
                  value={cancha.nombre}
                  onChange={e => actualizar(index, 'nombre', e.target.value)}
                  placeholder="Ej: Cancha 1, Cancha Norte..."
                  style={styles.input}
                />
              </div>
              <div style={{ flex: 1 }}>
                <label style={styles.label}>Superficie</label>
                <select
                  value={cancha.superficie}
                  onChange={e => actualizar(index, 'superficie', e.target.value)}
                  style={styles.select}
                >
                  <option value="">Selecciona</option>
                  {SUPERFICIES.map(s => <option key={s}>{s}</option>)}
                </select>
              </div>
            </div>

            {/* Precio y techada */}
            <div style={styles.rowDos}>
              <div style={{ flex: 1 }}>
                <label style={styles.label}>Precio por hora ($)</label>
                <input
                  type="number"
                  value={cancha.precio}
                  onChange={e => actualizar(index, 'precio', e.target.value)}
                  placeholder="28000"
                  style={styles.input}
                />
              </div>
              <div style={{ flex: 1, display: 'flex', alignItems: 'flex-end', paddingBottom: 2 }}>
                <div
                  onClick={() => actualizar(index, 'techada', !cancha.techada)}
                  style={styles.toggleWrap}
                >
                  <div style={{
                    ...styles.toggle,
                    background: cancha.techada ? '#1A6BFF' : '#E8ECF4',
                  }}>
                    <div style={{
                      ...styles.toggleKnob,
                      left: cancha.techada ? 14 : 2,
                    }} />
                  </div>
                  <span style={styles.toggleLabel}>Techada / Indoor</span>
                </div>
              </div>
            </div>

            {/* Horario disponible de esta cancha */}
            <div style={styles.campo}>
              <label style={styles.label}>Horario disponible</label>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                {FRANJAS_HORAS.map(({ id, label, horas }) => {
                  const abierta = (franjasAbiertas[index] || []).includes(id);
                  const horasSeleccionadas = horas.filter(h => (cancha.horas_disponibles || []).includes(h));
                  return (
                    <div key={id}>
                      <div onClick={() => toggleFranja(index, id)}
                        style={{
                          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                          padding: '9px 12px', borderRadius: 10, cursor: 'pointer',
                          border: `1.5px solid ${abierta ? '#1A6BFF' : '#E8ECF4'}`,
                          background: abierta ? '#EFF5FF' : 'white',
                        }}>
                        <span style={{
                          fontSize: 13, fontWeight: 700,
                          color: abierta ? '#1A6BFF' : '#4A5568',
                          fontFamily: "'Barlow Condensed', sans-serif",
                        }}>
                          {label}
                        </span>
                        <span style={{ fontSize: 11, color: '#9BA5B7', fontFamily: "'Barlow', sans-serif" }}>
                          {horasSeleccionadas.length > 0
                            ? `${horasSeleccionadas.length} hora${horasSeleccionadas.length > 1 ? 's' : ''} ✓`
                            : abierta ? '▲' : '▼'}
                        </span>
                      </div>
                      {abierta && (
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, padding: '8px 4px 2px' }}>
                          {horas.map(hora => {
                            const activo = (cancha.horas_disponibles || []).includes(hora);
                            return (
                              <div key={hora} onClick={() => toggleHora(index, hora)}
                                style={{
                                  padding: '6px 14px', borderRadius: 20, cursor: 'pointer',
                                  fontSize: 12, fontWeight: 700, fontFamily: "'Barlow', sans-serif",
                                  background: activo ? '#1A6BFF' : '#F4F6FA',
                                  color: activo ? 'white' : '#6B7280',
                                  border: `1px solid ${activo ? '#1A6BFF' : '#E8ECF4'}`,
                                }}>
                                {hora}
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
              {(cancha.horas_disponibles || []).length === 0 && (
                <p style={{ fontSize: 11, color: '#EF4444', fontFamily: "'Barlow', sans-serif", marginTop: 6 }}>
                  Sin horario definido — esta cancha no aparecerá disponible para nadie hasta que agregues horas.
                </p>
              )}
            </div>
          </div>
        ))}
      </div>

      <button style={styles.agregarBtn} onClick={agregar}>
        + Agregar otra cancha
      </button>

      {error && <p style={styles.error}>{error}</p>}

      <div style={styles.botones}>
        <button style={styles.btnBack} onClick={onBack}>← Atrás</button>
        <button style={styles.btnNext} onClick={handleNext}>Siguiente →</button>
      </div>
    </div>
  );
}

const styles = {
  wrap: { width: '100%' },
  titulo: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 26, fontWeight: 800, color: '#141922', marginBottom: 4,
  },
  sub: {
    fontSize: 13, color: '#6B7280',
    fontFamily: "'Barlow', sans-serif", marginBottom: 20, lineHeight: 1.5,
  },
  canchasList: {
    display: 'flex', flexDirection: 'column', gap: 16, marginBottom: 12,
  },
  canchaCard: {
    background: '#F4F6FA', borderRadius: 14, padding: '16px',
  },
  canchaHeader: {
    display: 'flex', justifyContent: 'space-between',
    alignItems: 'center', marginBottom: 14,
  },
  canchaNum: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 16, fontWeight: 700, color: '#141922',
  },
  eliminarBtn: {
    background: 'transparent', border: 'none',
    fontSize: 12, color: '#EF4444',
    cursor: 'pointer', fontFamily: "'Barlow', sans-serif",
  },
  campo: { marginBottom: 12 },
  rowDos: { display: 'flex', gap: 12, marginBottom: 12 },
  label: {
    display: 'block', fontSize: 11, fontWeight: 700,
    color: '#6B7280', textTransform: 'uppercase',
    letterSpacing: '0.05em', marginBottom: 6,
    fontFamily: "'Barlow', sans-serif",
  },
  input: {
    width: '100%', padding: '10px 12px',
    border: '1.5px solid #E8ECF4', borderRadius: 9,
    fontSize: 13, color: '#141922',
    fontFamily: "'Barlow', sans-serif",
    outline: 'none', boxSizing: 'border-box',
    background: 'white',
  },
  select: {
    width: '100%', padding: '10px 12px',
    border: '1.5px solid #E8ECF4', borderRadius: 9,
    fontSize: 13, color: '#141922',
    fontFamily: "'Barlow', sans-serif",
    outline: 'none', boxSizing: 'border-box',
    background: 'white',
  },
  tiposGrid: {
    display: 'grid', gridTemplateColumns: 'repeat(5, 1fr)', gap: 8,
  },
  tipoCard: {
    borderRadius: 10, padding: '10px 6px',
    cursor: 'pointer', transition: 'all 0.12s',
    textAlign: 'center',
  },
  tipoIcono: { fontSize: 20, marginBottom: 4 },
  tipoLabel: {
    fontSize: 11, fontWeight: 600, color: '#141922',
    fontFamily: "'Barlow', sans-serif",
  },
  toggleWrap: {
    display: 'flex', alignItems: 'center', gap: 8,
    cursor: 'pointer',
  },
  toggle: {
    width: 32, height: 18, borderRadius: 9,
    position: 'relative', transition: 'background 0.15s',
    flexShrink: 0,
  },
  toggleKnob: {
    width: 14, height: 14, borderRadius: '50%',
    background: 'white', position: 'absolute',
    top: 2, transition: 'left 0.15s',
  },
  toggleLabel: {
    fontSize: 12, color: '#4A5568',
    fontFamily: "'Barlow', sans-serif",
  },
  agregarBtn: {
    width: '100%', padding: '10px',
    background: 'transparent',
    border: '1.5px dashed #E8ECF4',
    borderRadius: 10, fontSize: 13, fontWeight: 600,
    color: '#9BA5B7', cursor: 'pointer',
    fontFamily: "'Barlow', sans-serif", marginBottom: 16,
  },
  error: {
    color: '#EF4444', fontSize: 12,
    fontFamily: "'Barlow', sans-serif", marginBottom: 12,
  },
  botones: {
    display: 'grid', gridTemplateColumns: '1fr 2fr', gap: 10,
  },
  btnBack: {
    padding: '13px', background: 'white',
    border: '1.5px solid #E8ECF4', borderRadius: 12,
    fontSize: 14, fontWeight: 700, color: '#6B7280',
    cursor: 'pointer',
    fontFamily: "'Barlow Condensed', sans-serif",
  },
  btnNext: {
    padding: '13px', background: '#FF6B1A',
    border: 'none', borderRadius: 12,
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 17, fontWeight: 800,
    color: 'white', cursor: 'pointer',
  },
};
